import { Copy } from '@ev-tech/ui-core-components/Copy';
import { DEFAULT_IMAGE, getUploadCareImageUrl } from '@ev-tech/search-modules-api';

import { useRestrictedSearchResultCardContext } from './SearchResultCardProvider';
import { SearchResultCardImageLinkWrapper } from './SearchResultCardImageLinkWrapper';
import { CarouselImage } from '../Carousel';
import { ViewportSize as viewportSizes } from '../../utils/mediaQueries';
import { getUploadcareImageTransformationProps } from '../../utils/getUploadcareImageTransformationProps';
import LockClosedIcon from '../../assets/icons/medium/LockClosed.svg';

import styles from './SearchResultCardImage.module.css';

export const RestrictedSearchResultCardImage = () => {
  const {
    carouselPreloadIndex,
    fallbackImage,
    imageComponent,
    link,
    listing,
    shouldHideImage,
    shouldPreloadImage,
    translationResolver: t,
    variant,
  } = useRestrictedSearchResultCardContext();
  const sourceImage = listing.uploadCareImages?.[0];
  const image = sourceImage?.id
    ? getUploadCareImageUrl({ imageId: sourceImage.id, useWaterMark: false, isBlurred: true })
    : DEFAULT_IMAGE + '-/blur/200/';

  return (
    <div className={styles.restrictedImageWrapper}>
      <SearchResultCardImageLinkWrapper>
        <div className={styles.restrictedOverlay}>
          <LockClosedIcon className={styles.lockClosedIcon} />
          {variant !== 'preview' && (
            <Copy
              className={styles.restrictedOverlayCopy}
              size="s"
              bold
              text={t('search.results.listingCard.privateOffice.overlayLabel')}
            />
          )}
        </div>
        <CarouselImage
          src={image}
          sizes={`(max-width: ${viewportSizes.TABLET_PORTRAIT}px) 100vw, (max-width: ${viewportSizes.LAPTOP}px) 50vw, 33vw`}
          imageStyles={{ borderRadius: 'var(--border-radius-s) var(--border-radius-s) 0 0' }}
          inView
          imageComponent={imageComponent}
          shouldPreloadImage={shouldPreloadImage}
          width={360}
          height={240}
          fallbackImage={fallbackImage}
          aspectRatio="3/2"
          alt={link.label}
          focalPoint={sourceImage?.focalPoint}
          {...getUploadcareImageTransformationProps({
            aspectRatio: '3/2',
            fit: sourceImage?.id ? 'automatic' : 'cover',
            image: sourceImage,
          })}
          shouldHideImage={shouldHideImage}
          carouselPreloadIndex={carouselPreloadIndex}
        />
      </SearchResultCardImageLinkWrapper>
    </div>
  );
};
